import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { brandPath, mainSiteHref } from '../utils/brandRouting';
import { products } from '../data/siteContent';

const CARDCYCLE = products.find((product) => product.id === 'cardcycle');

export default function CCNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const backHref = mainSiteHref();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', fn, { passive: true }); fn();
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <>
      <nav className={`cc-navbar${scrolled ? ' scrolled' : ''}`} data-testid="cc-navbar">
        <div className="wrap">
          <Link to={brandPath('cardcycle')} className="cc-brand">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <rect width="28" height="28" rx="7" fill="#0255E6"/>
              <rect x="4" y="10" width="15.5" height="11" rx="2.2" stroke="white" strokeWidth="1.8"/>
              <rect x="4.5" y="13.5" width="14.5" height="2" fill="white"/>
              <path d="M21 8a7 7 0 1 1 -2.5-1.7" stroke="#5EB7F8" strokeWidth="1.8" strokeLinecap="round"/>
              <path d="M21 4v4h-4" stroke="#5EB7F8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="cc-brand-name">Card<span>Cycle</span></span>
          </Link>

          <div className="nav-links">
            <Link to={brandPath('cardcycle', '/privacy')} className="cc-nav-link">Privacy</Link>
            <Link to={brandPath('cardcycle', '/terms')} className="cc-nav-link">Terms</Link>
            <Link to={brandPath('cardcycle', '/faq')} className="cc-nav-link">FAQ</Link>
            <Link to={brandPath('cardcycle', '/account-deletion')} className="cc-nav-link">Delete data</Link>
            {backHref
              ? <a href={backHref} className="cc-back-link"><i className="fas fa-arrow-left"></i> TickleApps</a>
              : <Link to="/" className="cc-back-link"><i className="fas fa-arrow-left"></i> TickleApps</Link>}
          </div>

          <div className="nav-right">
            <a href={CARDCYCLE.storeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-cc btn-sm" data-testid="cc-download-btn">{CARDCYCLE.storeLabel}</a>
          </div>
          <button
            className={`hamburger${open ? ' open' : ''}`}
            onClick={() => setOpen(o => !o)}
            aria-label="Menu"
            aria-expanded={open}
            aria-controls="cc-nav-drawer"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      <div id="cc-nav-drawer" className={`nav-drawer${open ? ' open' : ''}`} style={{ background: '#F5F8FF' }}>
        <Link to={brandPath('cardcycle', '/privacy')} className="cc-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>Privacy</Link>
        <Link to={brandPath('cardcycle', '/terms')} className="cc-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>Terms</Link>
        <Link to={brandPath('cardcycle', '/faq')} className="cc-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>FAQ</Link>
        <Link to={brandPath('cardcycle', '/account-deletion')} className="cc-nav-link" style={{ fontSize: '1.1rem', padding: '14px 16px' }}>Delete data</Link>
        {backHref
          ? <a href={backHref} className="cc-back-link" style={{ fontSize: '0.9rem', padding: '12px 16px' }}><i className="fas fa-arrow-left"></i> Back to TickleApps</a>
          : <Link to="/" className="cc-back-link" style={{ fontSize: '0.9rem', padding: '12px 16px' }}><i className="fas fa-arrow-left"></i> Back to TickleApps</Link>}
        <a href={CARDCYCLE.storeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-cc" style={{ width: '100%', justifyContent: 'center', marginTop: 'auto' }}>{CARDCYCLE.storeLabel}</a>
      </div>
    </>
  );
}
